import { render, staticRenderFns } from "./personageCenter.vue?vue&type=template&id=beb61982&scoped=true&"
import script from "./personageCenter.vue?vue&type=script&lang=js&"
export * from "./personageCenter.vue?vue&type=script&lang=js&"
import style1 from "./personageCenter.vue?vue&type=style&index=1&id=beb61982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb61982",
  null
  
)

export default component.exports